import SignupForm from './SignupForm';
import { userActions } from '../../redux/actions/userActions';
import { connect } from 'react-redux';
import { getFormValues, getFormSubmitErrors } from 'redux-form';

const mapStateToProps = state => {
  const initialFormValues = getFormValues('SignupForm')(state);
  const {
    authentication: { loggining, error },
    form: { SignupForm }
  } = state;
  return {
    initialValues: {
      ...initialFormValues,
      source_url: window.location.origin + '/login'
    },
    submitError: SignupForm && SignupForm.submitSucceeded && error,
    loggining,
    submitErrors: getFormSubmitErrors('SignupForm')(state)
  };
};

const mapDispatchToProps = dispatch => ({
  onSubmit: user => dispatch(userActions.signup(user))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupForm);



// WEBPACK FOOTER //
// ./src/components/signUp/SignupFormContainer.js